import { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";

export const LoginPage = () => {
	const { login } = useAuth();
	const [error, setError] = useState(null);
	const [showManualRetry, setShowManualRetry] = useState(false);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			try {
				await login();
			} catch (err) {
				if (cancelled) return;
				console.error("login redirect failed:", err);
				setError(err?.message || "Login redirect failed");
			}
		})();
		// If we're still on this page after 5s, surface a manual button so the
		// user isn't stuck watching an infinite spinner when the redirect
		// silently fails (blocked popup, WebAuthn cancel, etc).
		const timer = setTimeout(() => setShowManualRetry(true), 5000);
		return () => {
			cancelled = true;
			clearTimeout(timer);
		};
	}, [login]);

	const handleRetry = () => {
		setError(null);
		setShowManualRetry(false);
		login().catch((err) => setError(err?.message || "Login redirect failed"));
	};

	return (
		<div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-app)]">
			<div className="text-center max-w-sm px-6">
				<div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-accent)] border-t-transparent mx-auto" />
				<p className="mt-4 text-[var(--color-text-secondary)]">
					Redirecting to login...
				</p>
				{error && (
					<p className="mt-3 text-sm text-[var(--color-error-text)]">{error}</p>
				)}
				{(showManualRetry || error) && (
					<button
						type="button"
						onClick={handleRetry}
						className="mt-4 inline-flex items-center px-3 py-1.5 rounded-md bg-[var(--color-accent)] text-white text-sm hover:opacity-90"
					>
						Sign in again
					</button>
				)}
			</div>
		</div>
	);
};
